import React, {useContext, useRef} from "../../_snowpack/pkg/react.js";
import {Popover, Transition} from "../../_snowpack/pkg/@headlessui/react.js";
import {SearchIcon, CogIcon} from "../../_snowpack/pkg/@heroicons/react/outline.js";
import SettingSwitch from "./SettingSwitch.js";
import {useAutocomplete} from "../hooks/search-hook.js";
import useInput from "../hooks/input-hook.js";
import {SettingsContext} from "../App.js";
import AmiiboTypeSwitcher from "./AmiiboTypeSwitcher.js";
const SearchBar = ({search}) => {
  const popoverRef = useRef(null);
  const [settings] = useContext(SettingsContext);
  const {
    setValue: setName,
    onChange: _,
    ref: inputRef,
    ...textField
  } = useInput("text");
  const nameSuggestions = useAutocomplete(textField.value);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-row py-2 bg-red-600 dark:bg-gray-900"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-row gap-4 p-2 mx-auto"
  }, /* @__PURE__ */ React.createElement(Popover, {
    className: "relative"
  }, ({open}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("form", {
    onSubmit: (event) => search(event, textField.value)
  }, /* @__PURE__ */ React.createElement("input", {
    placeholder: "Search amiibo",
    ref: inputRef,
    className: "w-64 sm:w-96 p-2 focus:outline-none caret-red-500 dark:caret-gray-900 dark:bg-gray-500 dark:placeholder-white dark:text-white rounded-md",
    onChange: (event) => {
      event.preventDefault();
      if (!open) {
        popoverRef.current?.click();
        inputRef.current?.focus();
      }
      setName(event.target.value);
    },
    ...textField,
    spellCheck: "false"
  }), /* @__PURE__ */ React.createElement(Popover.Button, {
    ref: popoverRef,
    tabIndex: -1
  }), /* @__PURE__ */ React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-75 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0"
  }, /* @__PURE__ */ React.createElement(Popover.Panel, {
    className: "absolute z-10 right-0 mt-1"
  }, ({close}) => nameSuggestions.length !== 0 && /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-2 bg-gray-50 dark:bg-gray-500 p-2 w-64 sm:w-96 rounded-md border border-gray-300 dark:border-gray-800"
  }, nameSuggestions.map((name, index) => /* @__PURE__ */ React.createElement("button", {
    key: `${name}-${index}`,
    className: "text-left transition-all duration-200 ease-in-out hover:font-bold hover:bg-red-200 dark:hover:bg-gray-800 hover:text-red-500 dark:hover:text-white p-2 cursor-pointer rounded-md focus:outline-none focus-visible:ring focus-visible:ring-red-500 dark:focus-visible:ring-gray-700",
    onClick: (_2) => {
      setName(name);
      close(inputRef);
    }
  }, /* @__PURE__ */ React.createElement("span", {
    className: "dark:text-white"
  }, name))))))))), /* @__PURE__ */ React.createElement("button", {
    onClick: (event) => search(event, textField.value)
  }, /* @__PURE__ */ React.createElement(SearchIcon, {
    className: "h-7 w-7 text-white hover:text-gray-200 transition duration-100 ease-in-out hover:scale-110"
  }))), /* @__PURE__ */ React.createElement(Popover, {
    className: "flex flex-row my-auto relative"
  }, /* @__PURE__ */ React.createElement(Popover.Button, null, /* @__PURE__ */ React.createElement(CogIcon, {
    className: "h-7 w-7 text-white mr-4 transition duration-100 ease-in-out hover:rotate-[24deg] hover:text-gray-200 hover:scale-110 my-auto"
  })), /* @__PURE__ */ React.createElement(Popover.Panel, {
    className: "absolute z-10 top-10 right-2"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "dark:text-white flex flex-col gap-2 divide-y-2 dark:divide-gray-900 bg-gray-50 dark:bg-gray-500 p-4 w-64 rounded-md border border-gray-300 dark:border-gray-800"
  }, /* @__PURE__ */ React.createElement(SettingSwitch, {
    label: "Dark Mode",
    setting: "darkMode",
    value: settings.darkMode
  }), /* @__PURE__ */ React.createElement(AmiiboTypeSwitcher, null))))));
};
export default SearchBar;
